import { alphabetStandardLowercase } from "@nvon/baseline";
import { customAlphabet } from "nanoid";
import { useRef } from "react";
const generator = customAlphabet(alphabetStandardLowercase, 10);
/**
 * Generates a unique id that only changes when the component is mounted.
 */
export const useId = (prefix, separator = "_") => {
    return useRef(prefix ? `${prefix}${separator}${generator()}` : generator())
        .current;
};
//# sourceMappingURL=useId.js.map